import React, {Fragment} from 'react';

const UpdateDoneStep = () => {
  return (
    <Fragment>
      <div>
        Your scanner is up-to-date and is ready to use.<p/>
        You can now close this window.
      </div>
    </Fragment>
  );
};

export default UpdateDoneStep;
